<template>
  <div class="raceDetails pa-3">
    <v-row no-gutters justify="center">
      <v-card id="cardTest">
        <v-card-title
          class="my-1 accent"
        >
          <v-icon>far fa-tags</v-icon>
          <span
            depressed
            class="font-weight-bold text-left text-uppercase text-customizer-exp"
            v-html="$t('dashboard.menu.raceDetails.race_classes_setup')"
            >{{ $t("dashboard.menu.raceDetails.race_classes_setup") }}</span
          >
        </v-card-title>

        <RaceClasses />
      </v-card>
    </v-row>
  </div>
</template>

<script>
import RaceClasses from "@/components/dashboard/raceDetails/RaceClasses.vue";

export default {
  components: {
    RaceClasses
  }
}
</script>